﻿import { MapSgs } from './map/map.js';
import { Pdm } from './pdm.js';
import { Occurrences } from './occurrences.js';
import { Utility } from './Utility.js';
export { Sgs };

/**
 * Class SGS
 * @param {object} mapSettings, An object with the map settings
 */
const Sgs = function (mapSettings) {
    // Define this
    var mySgs = this;

    // -- begin public variable -------------------------------------------------------------------

	// Map class definition
    this.Map = new MapSgs(mapSettings);

    // Pdm definition
    if (mapSettings.operation_visible.PDM)
        this.Pdm = new Pdm();

    // Occurrence definition
    if (mapSettings.operation_visible.Occurrence || mapSettings.operation_visible.OccurrenceEvent)
        this.Occurrences = new Occurrences();

    // -- end public variable ---------------------------------------------------------------------

    // -- begin private variable ------------------------------------------------------------------

    // Utility
    this._utility = new Utility();

    // -- end private variable --------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Init Sgs
     */
    this.Init = function () {

        // Init msg toastr
        var showDurationMsg = mySgs._utility.GetPropertyInfoInConfigArray(mySgs.Map._settings._mapSettings.configuration_info.propertyInfo, "TOASTR", "CONFIGURATION", "SHOW_DURATION");
        if(showDurationMsg == undefined)
            showDurationMsg = "2000";
        mySgs._utility.InitToastr(showDurationMsg.value);;

        // Create Map
        mySgs.Map.CreateMap();

        // Init Map
        mySgs.Map.Init();

        // Get visible operation
        let visibleOperations = mySgs.Map.getSettings().getVisibleOperations();

        // Init tooltips goto detail
        if (visibleOperations.DetailLayer) {
            $('#id-offcanvas-layer-detail').attr("mode", "read");
            mySgs.Map.tooltips.SetGotoEntityCallback(mySgs.Map.DetailElement);
        }

        // Init Pdm
        if (visibleOperations.PDM) {
            mySgs.Pdm.Init(mySgs.Map.map, mySgs.Map.layerTree.layerTreeObj, visibleOperations.PDM, mySgs.Map.getSettings()._mapSettings.map_info.cod_owner, mySgs.Map.getSettings().userInfo.userId);
        }

        // Init Occurrence
        if (visibleOperations.Occurrence) {
            mySgs.Occurrences.InitOccurrences(mySgs.Map, visibleOperations.Occurrence);

            // Set tooltips goto Entity occurrence function callback
            if (visibleOperations.Tooltips)
                mySgs.Map.tooltips.SetGotoEntityCallback(mySgs.Occurrences._DetailOccurrence);
        }

        // Init Occurrence event
        if (mapSettings.operation_visible.OccurrenceEvent) {
            mySgs.Occurrences.InitEventOccurrence(mySgs.Map, visibleOperations.OccurrenceEvent);

            // Set tooltips goto Entity occurrence function callback
            if (visibleOperations.Tooltips)
                mySgs.Map.tooltips.SetGotoEntityCallback(mySgs.Occurrences._DetailOccurrence);

        }
    };

    // -- end public method -----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    /**
     * Event to close area info
     */
    $('#close-offcanvas-info').on('click', function () {
        // If layer edition then close cancel layer edition
        if (mySgs.Map.layerTree._onEdit)
            mySgs.Map.layerTree.CloseEdition(true);
        else
            $('#offcanvas-info').removeClass('show');
    });

    /**
     * Collapse/open info in any option title
     */
    $('.option-title-collapse').on('click', function () {
        var idNodeToCollapse = this.getAttribute('target-id');
        $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');

        $('#' + idNodeToCollapse).toggle('ol-hidden');
    });

    // -- end event -------------------------------------------------------------------------------
};